module.exports = __webpack_public_path__ + "img/NAVISTAR.81a95f8d.svg";